import { RATINGS_TOTAL_STARS } from '@atlassian/amkt-common';
import { formatISO } from 'date-fns';
import React from 'react';
import { JsonLd } from 'react-schemaorg';
export const APPLICATION_CATEGORY_ADD_ONS = 'Add-ons';

const AppStructuredData = props => {
  const {
    name,
    icon: image,
    description,
    review: {
      rating: ratingValue,
      count: reviewCount
    },
    partner: {
      name: partnerName,
      url: partnerUrl
    },
    createdAt,
    compatibleProducts
  } = props;
  const app = {
    '@type': 'SoftwareApplication',
    name,
    image,
    description,
    dateCreated: formatISO(createdAt),
    applicationCategory: APPLICATION_CATEGORY_ADD_ONS,
    applicationSuite: compatibleProducts.map(product => product.name).join(', ')
  };

  if (reviewCount > 0) {
    app.aggregateRating = {
      '@type': 'AggregateRating',
      bestRating: RATINGS_TOTAL_STARS,
      ratingValue,
      reviewCount
    };
  }

  if (partnerName) {
    app.creator = {
      '@type': 'Organization',
      name: partnerName,
      ...(partnerUrl && {
        url: partnerUrl
      })
    };
  }

  return /*#__PURE__*/React.createElement(JsonLd, {
    item: app
  });
};

export default AppStructuredData;